import {Nullable} from '../../../app/TypeHelpers'
import {OvernightFacilitySetting} from '../../facilities/FacilityForReservation'
import {PAYMENT_TYPE} from '../../../CodeMaster'
import ReservePaymentCalculator from './ReservePaymentCalculator'
import {ReserveOptionPaymentCalculator} from './ReserveOptionPaymentCalculator'
import {PaymentItemForViewOvernight} from '../element/PaymentItemForViewOvernight'
import {PaymentItem} from '../ReserveFacilityModel'

export class ReservePaymentCalculatorOvernight extends ReservePaymentCalculator {

    private readonly overnightFacilityData: Nullable<OvernightFacilitySetting> = null
    private readonly startDate: Nullable<string> = null
    private readonly stayCount: Nullable<number> = null

    constructor(
        overnightFacilityData: OvernightFacilitySetting | null,
        startDate: string | null,
        stayCount: number | null,
        optionCalculator: ReserveOptionPaymentCalculator,
    ) {
        super(optionCalculator)
        this.overnightFacilityData = overnightFacilityData
        this.startDate = startDate
        this.stayCount = stayCount
    }

    protected calculateFacilityPayment(): PaymentItem {
        if (this.overnightFacilityData === null || this.stayCount === null) {
            throw Error('this.overnightFacilityData === null || this.stayCount === null')
        }

        return new PaymentItemForViewOvernight(
            PAYMENT_TYPE.ADMIN_TRANSFER_ACCOUNT,
            this.overnightFacilityData.stayCharge * this.stayCount,
            this.stayCount,
        ).toObject()
    }

    isEnableCalculate(): boolean {
        if (this.overnightFacilityData === null) {
            return false
        }

        if (this.startDate === null) {
            return false
        }

        // noinspection RedundantIfStatementJS
        if (this.stayCount === null) {
            return false
        }

        return true
    }
}
